const ALLOWED_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:'];

/**
 * Sanitize a URL to prevent XSS via dangerous protocols.
 * Decodes URL-encoded characters and null bytes before checking.
 * Returns '#' for anything dangerous or malformed.
 */
export function sanitizeUrl(url) {
  if (!url || typeof url !== 'string') return '#';

  let decoded = url.trim();
  if (!decoded) return '#';

  // Decode URL-encoded characters to catch evasion attempts (e.g., java%09script:)
  try {
    decoded = decodeURIComponent(decoded);
  } catch {
    // Invalid URL encoding — treat as suspicious
    return '#';
  }

  // Strip null bytes and control characters — deliberate security measure:
  // control chars are used to evade protocol checks (e.g. "java\x00script:").
  // eslint-disable-next-line no-control-regex
  decoded = decoded.replace(/[\x00-\x1F]/g, '');

  // Check for dangerous protocols after decoding
  if (/^(javascript|data|vbscript)\s*:/i.test(decoded)) return '#';

  // Allow relative paths (start with / or alphanumeric)
  if (decoded.startsWith('/') || decoded.startsWith('#')) return decoded;

  // Validate absolute URLs via URL constructor
  try {
    const parsed = new URL(decoded);
    if (!ALLOWED_PROTOCOLS.includes(parsed.protocol)) return '#';
    return parsed.href;
  } catch {
    // Not a valid absolute URL — allow if it looks like a relative path
    if (/^[a-zA-Z0-9]/.test(decoded) && !decoded.includes(':')) return decoded;
    return '#';
  }
}
